// extracted by mini-css-extract-plugin
export default {"signupTermsOfService":"f31lXf","link":"mQUhuA"};